!customElements.get('hoculus-swiper') &&
    customElements.define('hoculus-swiper', class extends HTMLElement {
        slidesTemplate = this.querySelector('[data-slides]');
        /* 
        add
        <template data-slides>
            <div class="swiper-slide">Slide 1</div>
        </template>
        to load slides after initialization
        */

        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        async init() {
            if (!window.Swiper) await this.loadSwiper();
            if (!window.Swiper) return console.error('Failed to load Swiper');
                
            this.config = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent ?? null);
            if (!this.config) return console.error('No configuration found');

            this.swiper = new Swiper(this.querySelector('.swiper'), this.config);

            // if there is slidesTemplate, it means that slides should be appended to swiper after initialization
            if (this.slidesTemplate) this.appendSlides();

            // Add class to show slides after initialization
            this.classList.add('visible-swiper-slides');
        }

        loadSwiper() {
            console.clear()
            console.log('loading swiper')
            return Promise.all([
                window.hoculus.Utils.getCssAsync(window.hoculus.assets.css.swiper),
                window.hoculus.Utils.getScriptAsync(window.hoculus.assets.js.swiper),
            ]);
        }

        appendSlides() {
            const swiperSlides = this.slidesTemplate.content.cloneNode(true).querySelectorAll('.swiper-slide');
            this.swiper.appendSlide(swiperSlides)
        }
    });